export default "/assets/images/mila-box.b584e2d2a3d8d2a4.png";